import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { fetchFinanceLedgersLi } from "../../../services/Settings/dropdown"
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap" // Import Offcanvas components
import LedgerForm from "../../../pages/Finance/ledger/edit"

const FinanceLedgersLi = ({
  control,
  name,
  onSelectChange,
  disabled,
  target,
  placeholder,
  clearable,
  filSupplier,
  ledgerTypes,
  groupId,
  selectedLedgers,
  onCreate,
  showCreateOption = false,
  refreshTrigger,
  onSuccess,
  notAccId,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [seriesData, setSeriesData] = useState([])
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false)
  const [formKey, setFormKey] = useState(0)

  const loadOptions = async () => {
  try {
    setIsLoading(true)
    const res = await fetchFinanceLedgersLi(
      filSupplier || "",
      ledgerTypes || "",
      groupId || "",
      notAccId || ""
    )

    console.log(`api `, res?.data);
    

    const groupedData = res?.data?.reduce((acc, item) => {
      const groupName = item.account_group_name || "Others"
      console.log(`groupName `, groupName, acc , item);
      
      if (!acc[groupName]) {
        acc[groupName] = { label: ucfirst(groupName), options: [] }
      }
      acc[groupName].options.push({
        label: ucfirst(item.name),
        value: item.id,
        ...item,
      })
      return acc
    }, {})

    let series = Object.values(groupedData)

    console.log(`groupedData`, groupedData);
    

    // Filter already selected ledgers
    if (selectedLedgers) {
      const selectedIds = Array.isArray(selectedLedgers)
        ? selectedLedgers.map(l => l.value)
        : [selectedLedgers?.value]

      series = series.map(group => ({
        ...group,
        options: group.options.filter(opt => !selectedIds.includes(opt.value)),
      }))
    }

    // Add create option
    if (showCreateOption && onCreate) {
      series.unshift({
        label: "Actions",
        options: [{ label: "Create", value: "create_new_ledger", isCreateOption: true }],
      })
    }

    setSeriesData(series)
  } catch (err) {
    console.error("Error fetching finance ledgers:", err)
  } finally {
    setIsLoading(false)
  }
}


  // useEffect(() => {
  //   loadOptions();
  //   console.log(`hi chkk chk `, filSupplier, ledgerTypes, groupId, selectedLedgers, refreshTrigger);

  // }, [filSupplier, ledgerTypes, groupId, selectedLedgers, refreshTrigger]);

  useEffect(() => {
    loadOptions()
  }, [
    filSupplier,
    ledgerTypes,
    JSON.stringify(groupId),
    JSON.stringify(selectedLedgers),
    refreshTrigger,
  ])

  const handleLedgerCreationSuccess = newLedger => {
    setIsOffcanvasOpen(false)
    setFormKey(prev => prev + 1)
    if (onSuccess) {
      onSuccess(newLedger, name)
    }
  }

  const handleChange = (selected, onChange) => {
    if (selected?.isCreateOption) {
      if (onCreate) {
        onCreate()
      } else {
        setIsOffcanvasOpen(true)
      }
      onChange(null) // Reset the select value
    } else {
      onChange(selected)
      if (onSelectChange) onSelectChange(selected)
    }
  }

  const enhancedSeriesData = React.useMemo(() => {
    let series = [...seriesData]

    if (showCreateOption && (onCreate || true)) {
      const actionsGroupIndex = series.findIndex(
        group => group.label === "Actions"
      )

      const createOption = {
        label: "Create",
        value: "create_new_ledger",
        isCreateOption: true,
      }

      if (actionsGroupIndex >= 0) {
        series[actionsGroupIndex].options = [
          createOption,
          ...series[actionsGroupIndex].options,
        ]
      } else {
        series.unshift({
          label: "Actions",
          options: [createOption],
        })
      }
    }

    return series
  }, [seriesData, showCreateOption, onCreate])
  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            // options={seriesData}
            options={enhancedSeriesData}
            // placeholder={placeholder}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
            isLoading={isLoading}
            isClearable={clearable}
            inputRef={ref}
            onChange={selected => handleChange(selected, onChange)}
            value={value}
            isDisabled={disabled}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.querySelector(target || ".modal")}
            filterOption={(option, rawInput) => {
              const input = rawInput.toLowerCase()
              const labelMatch = option.label?.toLowerCase().includes(input)
              const groupMatch = option.data?.account_group_name
                ?.toLowerCase()
                .includes(input)
      
              return labelMatch || groupMatch
            }}
          />
        )}
      />

      <Offcanvas
        isOpen={isOffcanvasOpen}
        toggle={() => setIsOffcanvasOpen(!isOffcanvasOpen)}
        direction="end"
        size="lg"
      >
        <OffcanvasHeader toggle={() => setIsOffcanvasOpen(false)}>
          Create
        </OffcanvasHeader>
        <OffcanvasBody>
          <LedgerForm
            isOffcanvas={true}
            isOpen={isOffcanvasOpen}
            toggleOffcanvas={() => setIsOffcanvasOpen(false)}
            onSuccess={handleLedgerCreationSuccess}
            key={formKey}
            defaultGroupId={groupId}
          />
        </OffcanvasBody>
      </Offcanvas>
    </div>
  )
}

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

export default FinanceLedgersLi
